module.exports = __webpack_public_path__ + "img/4_uk.532aa26a.svg";